var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('module-iframe',{attrs:{"module":"orders","src":"https://keyvue.app/omzet-toewijzing/"}},[(_vm.$currentCompany.pipelinesEnabled)?_c('orders-pipelines-enabled'):_c('orders-legacy')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }